const config = () => ({
  urls: [
    '.*recommendations\\.(stg\\.)?ws\\.blick\\.ch.*',
    '.*lotto\\.(stg\\.)?ws\\.blick\\.ch.*',
    '.*weather\\.(stg\\.)?ws\\.blick\\.ch.*',
  ],
})

export type configType = ReturnType<typeof config>
export default config
